module.exports = __webpack_public_path__ + "055b82e38d22882b9fc3f2344c45f5f2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-29.png
 ** module id = 1020
 ** module chunks = 0
 **/